// Order Configuration API
import queryString from 'query-string'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    StepTypeDetailed, SubstepName,
} from 'app/enums/label.enums'

type OrderConfigurationRequests = {
    getStepConfiguration: RequestConfigFunction<{
        stepTypeDetailed: StepTypeDetailed,
        stepProgress: SubstepName,
    }>,
}

const orderConfigurationRequests: OrderConfigurationRequests = {
    getStepConfiguration: ({
        stepTypeDetailed,
        stepProgress,
    }) => {
        return {
            url: queryString.stringifyUrl({
                url: 'order/step-configuration',
                query: {
                    stepTypeDetailed,
                    stepProgress,
                },
            }),
            method: 'GET',
        }
    },
}

export default orderConfigurationRequests
